import { Guid } from '../guid';
import { MapperBase } from '../../utilities/mapper-base';
import { CaseShardsResource } from '../resource/case-shards.resource';
import { CaseShards } from '../case-shards.model';
import { meanBy } from 'lodash-es';

export class CaseShardsResourceToCaseShardsMapper extends MapperBase<CaseShardsResource, CaseShards> {
	map(source: CaseShardsResource): CaseShards {
		const dest = new CaseShards();
		dest.caseId = source?.caseId ? source.caseId.toLowerCase() : Guid.Empty;
		dest.primaryShardCount = source?.shards?.filter(x => x.isPrimary == true).length;
		dest.replicaShardCount = source?.shards?.filter(x => x.isPrimary == false).length;
		dest.replicaPerPrimary = dest.primaryShardCount > 0 ? dest.replicaShardCount / dest.primaryShardCount : 0;
		dest.avgPrimaryBytes = source?.shards?.filter(x => x.isPrimary == true).length > 0 ?meanBy(source?.shards?.filter(x => x.isPrimary == true), function (o) { return o.bytesSize; }) : 0;
		dest.avgReplicaBytes = source?.shards?.filter(x => x.isPrimary == false).length > 0 ? meanBy(source?.shards?.filter(x => x.isPrimary == false), function (o) { return o.bytesSize}) : 0;
		return dest;
	}

}
